import { Checkbox, CheckboxGroup, Text, VStack } from '@chakra-ui/react';
import React from 'react';

import { DisplayShiftOption } from '@/types/ui.types';
import { ShiftToDisplay } from '@/types/view.types';

interface ViewLayoutShiftsToDisplayProps {
  onChange: (value: ShiftToDisplay[]) => void;
  options: DisplayShiftOption[];
  selected: string[];
  errorMessage?: string;
}

const ViewLayoutShiftsToDisplay = (props: ViewLayoutShiftsToDisplayProps): JSX.Element => {
  const { errorMessage, onChange, options, selected } = props;

  return (
    <VStack align={'left'} alignItems={'space-between'}>
      <Text>Display Shift</Text>
      <CheckboxGroup onChange={onChange} value={selected}>
        <VStack align={'left'} alignItems={'space-between'} justifyContent={'left'}>
          {options.map((option: DisplayShiftOption) => (
            <Checkbox key={option.name} name={option.name} value={option.value}>
              {option.label}
            </Checkbox>
          ))}
        </VStack>
      </CheckboxGroup>
      {errorMessage && (
        <Text color="red.500" fontSize="sm">
          {errorMessage}
        </Text>
      )}
    </VStack>
  );
};

export default ViewLayoutShiftsToDisplay;
